import React from 'react'
import { useTranslation } from 'react-i18next'

import { createBreadcrumbWithI18n } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  PageContainer,
  type PageContainerProps,
} from '~/components/elements/PageContainer'
import { Suspense } from '~/components/elements/Suspense'
import { VStack } from '~/components/elements/VStack'
import { useBrandAccountAiEnabledQuery } from '~/hooks/useBrandAccountAiEnabledQuery'
import { exists } from '~/utils'

import { useBrandAccountId } from './hooks/useBrandAccountId'
import { useCanEditAiSettings } from './hooks/useCanEditAiSettings'
import { AiToggleSection } from './sections/AiToggleSection'

export const AiSettingsPage = () => {
  const brandAccountId = useBrandAccountId()
  const { t } = useTranslation()
  const { data, isLoading } = useBrandAccountAiEnabledQuery(brandAccountId)
  const brandAccount = data?.brandAccount
  const canEdit = useCanEditAiSettings(brandAccountId)

  const createBreadcrumb = React.useMemo(() => createBreadcrumbWithI18n(t), [t])

  const breadcrumbs = React.useMemo<PageContainerProps['breadcrumbs']>(
    () => [
      createBreadcrumb('top', {}),
      createBreadcrumb('brandAccountSettings'),
      createBreadcrumb('aiSettings', { brandAccountId }),
    ],
    [brandAccountId, createBreadcrumb],
  )

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <Suspense loading={isLoading}>
        {exists(brandAccount) && (
          <VStack spacing={4} verticalAppearance="stretch">
            <AiToggleSection
              aiEnabled={brandAccount.aiEnabled}
              brandAccountId={brandAccount.id}
              canEdit={canEdit}
            />
          </VStack>
        )}
      </Suspense>
    </PageContainer>
  )
}
